import { render, staticRenderFns } from "./YesNoDialog.vue?vue&type=template&id=6f0fc5fa&scoped=true"
import script from "./YesNoDialog.vue?vue&type=script&lang=js"
export * from "./YesNoDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f0fc5fa",
  null
  
)

export default component.exports